import type { KpiCardSpec } from '~containers/analytics/kpis/card-spec';

export const ENROLLED_PLAYERS_CARDS: KpiCardSpec[] = [
    {
        title: 'Enrolled players',
        source: 'campaign-members',
        metric: 'enrolledMembers',
        form: 'number',
        size: 'md',
        description:
            'Players who enrolled in the edition, counted on the day they enrolled.',
    },
    {
        title: 'Enrolled players by cohort',
        source: 'campaign-members',
        metric: 'enrolledMembers',
        form: 'bars',
        breakdownBy: 'cohort',
        breakdownBaseMetricId: 'enrolledMembers',
        barBaseInHeader: true,
        size: 'md',
        description:
            'Existing accounts, created before the edition opened, against new ones created since.',
    },
    {
        title: 'Enrolled players over time',
        source: 'campaign-members',
        metric: 'enrolledMembers',
        form: 'line',
        chartStyle: 'area',
        palette: 'campaign',
        size: 'lg',
        description:
            'Players who enrolled on each day of the selected period, not a running total.',
    },
    {
        title: 'Enrolled players by BU',
        source: 'campaign-members',
        metric: 'enrolledMembers',
        form: 'columns',
        breakdownBy: 'businessUnit',
        palette: 'campaign',
        size: 'md',
        description: 'Enrolled players split by business unit.',
    },
    {
        title: 'Enrolled players by province',
        source: 'campaign-members',
        metric: 'enrolledMembers',
        form: 'bars',
        breakdownBy: 'province',
        breakdownBaseMetricId: 'enrolledMembers',
        barBaseInHeader: true,
        size: 'md',
        description:
            'Enrolled players split by the province they registered with.',
    },
];

export const BOOKLET_COLLECTION_CARDS: KpiCardSpec[] = [
    {
        title: 'Collectors',
        source: 'campaign-nhl-coins-collection',
        metric: 'collectors',
        form: 'number',
        size: 'sm',
        description:
            'Enrolled players holding at least one coin at the end of the period.',
    },
    {
        title: 'Complete booklets',
        source: 'campaign-nhl-coins-collection',
        metric: 'completeCollectors',
        form: 'number',
        size: 'sm',
        description:
            'Enrolled players holding all 20 coins at the end of the period.',
    },
    {
        title: 'Avg. coins per collector',
        source: 'campaign-nhl-coins-collection',
        metric: 'avgCoinsPerCollector',
        form: 'number',
        size: 'sm',
        description:
            'Average coins in the booklets of the players holding at least one, at the end of the period.',
    },
    {
        title: 'Booklets by draw entries',
        source: 'campaign-nhl-coins-collection',
        metric: 'enrolledMembers',
        form: 'columns',
        breakdownBy: 'entryTier',
        palette: 'campaign',
        size: 'sm',
        description:
            'One entry at enrolment, a second at 10 coins and a third at 20, at the end of the period.',
    },
    {
        title: 'Booklets by coins collected',
        source: 'campaign-nhl-coins-collection',
        metric: 'enrolledMembers',
        form: 'columns',
        breakdownBy: 'coinCount',
        palette: 'campaign',
        size: 'lg',
        description:
            'Enrolled players by the coins in their booklet at the end of the period, from none to all 20.',
    },
];

export const COIN_POPULARITY_CARDS: KpiCardSpec[] = [
    {
        title: 'Booklets holding each coin',
        source: 'campaign-nhl-coins-popularity',
        metric: 'coinsHeld',
        form: 'bars',
        breakdownBy: 'coin',
        barBaseInHeader: true,
        size: 'lg',
        description:
            'Booklets holding each coin at the end of the period, each bar its share of the enrolled booklets.',
    },
];
